import React, { createContext, useContext, useEffect, useState } from 'react';
import { brandingAPI } from '../services/api';

var DEFAULTS = {
  portal_name: 'OKC 2027',
  portal_tagline: 'Scholarship Portal',
  logo_url: '',
  website_primary: '#1a5276',
  website_secondary: '#e67e22',
};

var BrandingContext = createContext(DEFAULTS);

export function BrandingProvider(props) {
  var bs = useState(DEFAULTS);
  var branding = bs[0], setBranding = bs[1];

  useEffect(function() {
    brandingAPI.getPublic()
      .then(function(r) {
        if (r.data && r.data.data) {
          setBranding(Object.assign({}, DEFAULTS, r.data.data));
        }
      })
      .catch(function() { /* use defaults */ });
  }, []);

  return React.createElement(BrandingContext.Provider, { value: branding }, props.children);
}

export function useBranding() {
  return useContext(BrandingContext);
}
